export const HERO_CONSTANTS = {
  TAG: "Interior Design",
  DATE: "October 23, 2023",
  TITLE: "Boost Your Mood with Dopamine Decor",
  DESCRIPTION:
    "Discover how dopamine decor can enhance your living space and boost your mood. Learn about the principles of dopamine decor and how to incorporate them into your home.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/5678901/pexels-photo-5678901.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Dopamine decor is a design trend that focuses on creating spaces that boost your mood and well-being. This guide explores the principles of dopamine decor and how to incorporate them into your home.",
  "From vibrant colors to playful patterns, dopamine decor offers a range of design elements that can enhance your living space. We'll delve into the different aspects of dopamine decor and how to use them effectively.",
  "Whether you're looking to refresh your home or create a more joyful environment, dopamine decor provides a great solution. Let's explore the potential benefits and applications of dopamine decor in interior design.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Dopamine Decor",
    content:
      "Dopamine decor is a design trend that focuses on creating spaces that boost your mood and well-being. This trend incorporates vibrant colors, playful patterns, and joyful elements to create a positive and uplifting environment.",
  },
  {
    title: "2. Benefits of Using Dopamine Decor",
    content:
      "Dopamine decor offers several benefits, including improved mood, increased energy, and enhanced well-being. By incorporating elements that bring joy and positivity, dopamine decor can transform your living space into a happy and inviting environment.",
  },
  {
    title: "3. Applications in Interior Design",
    content:
      "Dopamine decor can be used in a variety of interior design projects, from living rooms to bedrooms. This trend is ideal for creating spaces that are both functional and joyful, making your home a more enjoyable place to live.",
  },
  {
    title: "4. Choosing the Right Elements for Dopamine Decor",
    content:
      "When selecting elements for dopamine decor, consider factors such as color, pattern, and texture. Look for items that bring joy and positivity, and don't be afraid to mix and match different elements to create a unique and personalized space.",
  },
  {
    title: "5. Tips for Incorporating Dopamine Decor",
    content:
      "To get the best results from dopamine decor, start with a clear vision of the mood you want to create and use the principles of color psychology to guide your choices. Experiment with different elements and have fun creating a space that reflects your personality and brings you joy.",
  },
  {
    title: "6. Maintenance and Updates",
    content:
      "Keep your dopamine decor fresh and updated by regularly adding new elements and making small changes to keep the space lively and engaging. This will help maintain the positive atmosphere and ensure that your living space continues to bring you joy.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/5678902/pexels-photo-5678902.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top Interior Design Trends for 2023",
    description:
      "Explore the latest interior design trends for 2023, from dopamine decor to sustainable materials. Learn how to incorporate these trends into your home or commercial space.",
  },
  {
    image:
      "https://images.pexels.com/photos/5678903/pexels-photo-5678903.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Create a Joyful Space with Dopamine Decor",
    description:
      "Discover practical tips for creating a joyful space with dopamine decor. Follow our step-by-step guide to achieve a happy and inviting environment.",
  },
  {
    image:
      "https://images.pexels.com/photos/5678904/pexels-photo-5678904.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Choosing the Right Elements for Your Interior Design Project",
    description:
      "Learn about the different elements available for interior design projects, from dopamine decor to natural materials. Understand the benefits and applications of each element to make informed design decisions.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Transform Your Space with Dopamine Decor",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/5678905/pexels-photo-5678905.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 Interior Design Trends. All rights reserved",
};
